import { actions } from 'react-redux-form';
import {httpPost, httpGet} from '../../../../utils/api.utils';
import {getViewMilestoneDetails, setMilestoneError, orderMilestoneModel, getMilestoneCircuitStatusesDropdown} from '../../../../constants/model-reducers/external/order/milestone/order-milestone.settings';
import { convertDateStringToDateFormat } from '../../../../utils/helpers.utils';
import { REQUEST_TYPE_MILESTONE, ORDER_STATUS } from '../../../../constants/external-constants';
import Moment from 'moment';

export const orderMilestoneFormInitialState = orderMilestoneModel;
const defaultState = ()=>({
    orderMilestoneError : false,
    milestoneDetails: [],
    isLoading: false
})
const initialState = defaultState;
export const orderMilestoneAction = {
    getOrderMilestone : (orderId, requestTypeId) => async (dispatch) => {
        const dealName = sessionStorage.getItem('DealName');
        try {
            dispatch({
                type: getViewMilestoneDetails,
                isLoading: true
            });
            const res = await httpGet(`external/milestone/Milestone/${dealName}/${orderId}/${requestTypeId}`);
            if (res.error) {
                dispatch({
                    type: setMilestoneError,
                    isLoading: false,
                    orderMilestoneError: true,
                    milestoneDetails: []
                });
            } else {
                dispatch({
                    type: getViewMilestoneDetails,
                    orderMilestoneError: false,
                    data: res.OrderMilestoneModel,
                    isLoading: false,
                });
                dispatch(actions.change('orderMilestoneForm.circuitRequestedDate', res.CircuitRequireDate ? convertDateStringToDateFormat(res.CircuitRequireDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.orderSubmitDate', res.OrderSubmitDate ? convertDateStringToDateFormat(res.OrderSubmitDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.carrierConfirmationDate', res.CarrierConfirmationDate ? convertDateStringToDateFormat(res.CarrierConfirmationDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.carrierTrackingID',res.CarrierTrackingID));
                dispatch(actions.change('orderMilestoneForm.telcoRepresentativeAssigned', res.TelcoRepresentativeAssigned));
                dispatch(actions.change('orderMilestoneForm.vendorCommitmentDeliveryDate', res.VendorCommitedDeliveryDate ? convertDateStringToDateFormat(res.VendorCommitedDeliveryDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.installOrdisconnectDate', (res.OrderDisconnectDate && res.OrderType === REQUEST_TYPE_MILESTONE.disconnect && res.OrderStatusID === ORDER_STATUS.completed) ? convertDateStringToDateFormat(res.OrderDisconnectDate, false) :
                                                                                      (res.OrderInstallDate && res.OrderType === REQUEST_TYPE_MILESTONE.simple) ? convertDateStringToDateFormat(res.OrderInstallDate, false) :
                                                                                      (res.OrderChangeDate && res.OrderType === REQUEST_TYPE_MILESTONE.change) ?     convertDateStringToDateFormat(res.OrderChangeDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.orderClosedDate', res.OrderClosedDate ? convertDateStringToDateFormat(res.OrderClosedDate, false) : null));
                dispatch(actions.change('orderMilestoneForm.orderType', res.OrderType));

            }
            return res;
        } catch (error) {
            console.error('Fetching milestones failed:', error);
            dispatch({
                type: setMilestoneError,
                orderMilestoneError: true,
                milestoneDetails: [],
                isLoading: false,
            });
            throw error;
        }
    },
    savedOrderMilestone: (orderId, requestTypeId, step, circuitStatusId) => async(dispatch,state) => {
        const dealName = sessionStorage.getItem('DealName');
        const {orderMilestoneForm} = state().form;
        const {orderSubmitDate,
            circuitRequestedDate,
            carrierConfirmationDate,
            carrierTrackingID,
            telcoRepresentativeAssigned,
            vendorCommitmentDeliveryDate,
            installOrdisconnectDate,
            orderClosedDate,orderType} = orderMilestoneForm;
            var data = {
                
                OrderSubmitDate: orderSubmitDate ? Moment(orderSubmitDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
                CircuitRequiredDate: circuitRequestedDate ? Moment(circuitRequestedDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
                CarrierConfirmationDate: carrierConfirmationDate ? Moment(carrierConfirmationDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
                CarrierTrackingID : carrierTrackingID,
                TelcoRepresentativeAssigned : telcoRepresentativeAssigned,
                VendorCommittedDeliveryDate: vendorCommitmentDeliveryDate ? Moment(vendorCommitmentDeliveryDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
                DisconnectDate : orderType === REQUEST_TYPE_MILESTONE.disconnect ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                InstallDate : orderType === REQUEST_TYPE_MILESTONE.simple ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                CircuitInstallDate : orderType === REQUEST_TYPE_MILESTONE.simple ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                CircuitDisconnectDate : orderType === REQUEST_TYPE_MILESTONE.disconnect ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                CircuitChangeDate : orderType === REQUEST_TYPE_MILESTONE.change ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                OrderCloseDate: orderClosedDate ? Moment(orderClosedDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
                ChangeOrderDate : orderType === REQUEST_TYPE_MILESTONE.change ? installOrdisconnectDate ? (Moment(installOrdisconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')) : null : null,
                Step : step,
                UserId: sessionStorage.getItem('UserID'),
                CircuitStatusId: circuitStatusId,
                RequestTypeID : requestTypeId
            }
            var res = await httpPost(`external/milestone/UpdateMilestoneStep/${dealName}/${orderId}`,data)
            if (res === false) {
                console.log("failed")
            }
        return res;
    },
    getMilestoneCircuitStatusesDropdown : () => async (dispatch) => {
        try {
            var res = await httpGet('external/circuit/getMilestoneCircuitStatusesDropdown');
            dispatch({
                type: getMilestoneCircuitStatusesDropdown,
                data: res
            });

        }catch (error) {
            console.error('Fetching milestones failed:', error);
            throw error;
        }
    },
};
export const reducer = (state,action) => {
    state = state || initialState;
    switch(action.type){
        case getViewMilestoneDetails :
            return {
                ...state,
                milestoneDetails: action.data,
                isLoading: action.isLoading
            }
        case setMilestoneError :
            return{
                ...state,
                orderMilestoneError: action.orderMilestoneError,
                milestoneDetails: action.milestoneDetails
            }
        case getMilestoneCircuitStatusesDropdown:
            return {
                ...state,
                milestoneCircuitStatusDropdown: action.data
            };
        default:
            return state
    }
}
